import type { fabric } from 'fabric';
import type { FabricEditor } from '../core/fabric-editor';
import type { Unsubscribe } from '../core/event-bus';
import type { EditorPlugin } from '../interfaces/editor-plugin';
import { FabricPluginName } from './plugin-name';

export interface SelectionFacade {
  getActive(): fabric.Object[];
  getFirst(): fabric.Object | null;
  clear(): void;
  set(target: fabric.Object): void;
}

declare module '../core/fabric-editor' {
  interface FabricEditor {
    selection?: SelectionFacade;
  }
}

export function selectionPlugin(): EditorPlugin {
  let first: fabric.Object | null = null;
  const unsubs: Unsubscribe[] = [];

  return {
    name: FabricPluginName.SELECTION,
    install(editor: FabricEditor) {
      unsubs.push(
        editor.on('selection:created', (e) => {
          first = e.selected[0] ?? null;
        }),
      );
      unsubs.push(
        editor.on('selection:changed', (e) => {
          if (e.active.length === 0) first = null;
        }),
      );

      editor.selection = {
        getActive: () => editor.canvas.getActiveObjects(),
        getFirst: () => first,
        clear: () => {
          editor.canvas.discardActiveObject();
          editor.canvas.requestRenderAll();
        },
        set: (target) => {
          editor.canvas.setActiveObject(target);
          editor.canvas.requestRenderAll();
        },
      };
    },
    dispose(editor: FabricEditor) {
      for (const off of unsubs) off();
      unsubs.length = 0;
      first = null;
      editor.selection = undefined;
    },
  };
}
